<template>
  <section class="invoice-preview-wrapper">
    <b-row class="invoice-preview">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card no-body class="invoice-preview-card">
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div
              class="
                d-flex
                justify-content-between
                flex-md-row flex-column
                invoice-spacing
                mt-0
              "
            >
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <logo />
                  <h3 class="text-primary invoice-logo">Sunnah</h3>
                </div>
                <p class="card-text mb-25">المملكة العربية السعودية</p>
                <p class="card-text mb-25">info@wahyeen.omg.com.eg</p>
                <p class="card-text mb-0">0101010101010</p>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  فاتورة
                  <span class="invoice-number"
                    ># {{ data.invoice_data.serial }}
                  </span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">تاريخ الإصدار:</p>
                  <p class="invoice-date">{{ data.invoice_data.date }}</p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Invoice Client & Payment Details -->
          <b-card-body class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <!-- Col: Invoice To -->
              <b-col cols="12" xl="6" class="p-0">
                <h6 class="mb-2">فاتورة إلى:</h6>
                <h6 class="mb-25">{{ user.full_name }}</h6>
                <p class="card-text mb-25">
                  {{ user.country }}
                </p>
                <p class="card-text mb-0">{{ user.email }}</p>
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">بيانات الدفع:</h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">الاجمالي المستحق:</td>
                        <td>
                          <span class="font-weight-bold">
                            {{ data.invoice_data.cost }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="pr-1">اسم البنك:</td>
                        <td>{{ data.all_bank_acounts[0].bank_name }}</td>
                      </tr>

                      <tr>
                        <td class="pr-1">رقم الحساب بصيغة IBAN:</td>
                        <td>{{ data.all_bank_acounts[0].account_number }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table :stacked="($mobile==1)" -lite hover :items="items" />

          <!-- Invoice Description: Total -->

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">ملاحظة: </span>

            <span>
              كان من دواعي سروري العمل معك ومع فريقك. نأمل أن تضعنا في اعتبارك
              لمشاريع العمل المستقل في المستقبل. اشكرك!</span
            >
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: DOwnload -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
          >
            تحميل
          </b-button>

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            طباعة
          </b-button>

          <!-- Button: Add Payment -->
          <b-button
            v-b-toggle.sidebar-invoice-add-payment
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-75"
            block
            @click="payment(data.invoice_data.id,data.eduProgram.id)"
          >
            الدفع
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
 import Controller from "../../../Controllers/EduProgramsController";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import Auth from "@/Apis/Auth";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,

    Logo,
  },
  data() {
    return {
      data: {},
      load: false,
      user: {},
      items: [],
    };
  },
  async created() {
    this.user = Auth.USER;
    let res = await new Controller().subscribe(this.$route.params.id);
    this.data = res;
    ["البرنامج", "السعر"];
    this.items = [
      {
        البرنامج: res.eduProgram.name,
        السعر: res.eduProgram.subscription_fees,
      },
    ];
  },
  methods: {
    payment(invoiceId,eduProgramId) {
      console.log(invoiceId,eduProgramId);
      this.$router.push({ name: "Payment", params: { invoiceId , eduProgramId } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
